<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">Sea-Export Consolidation Details</h3>
          </div>
          <hr class="hr-s" />
          <!-- /.box-header -->
          <div class="box-body">
            <table id="po" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <!-- <th>Sr no</th> -->
                  <th>Assignment</th>

                  <th>More Details</th>
                  <!-- <th>Container Load Type</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1, index) in FFExport" :key="index">
                  <!-- <td>{{index+1}}</td> -->
                  <td
                    @click="
                      viewExportFCLConPage(
                        item1.ffFclConsoExportId,
                        item1.statusFinal
                      )
                    "
                    class="showMoreData"
                  >
                    <b>Assignment No. :</b>
                    {{ item1.ffExportFclConsoSeries }}
                    <br />
                    <b>Client Name :</b>
                    {{ item1.clientName }}
                  </td>

                  <td>
                    <b>More Details:</b>
                    {{ item1.shippingLine }}
                    <br />
                    <b>Place of Receipt :</b>
                    {{ item1.placeRecp }}
                    <br />
                    <b>Load Port Name :</b>
                    {{ item1.LoadPort }}
                    <br />
                    <b>Port Of Discharge :</b>
                    {{ item1.placeDis }}
                    <br />
                    <b>Final Delivery :</b>
                    {{ item1.finalPlace }}
                  </td>

                  <!-- <td>{{item1.containerInfo}}</td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE } from "../../helper/constant.js";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Client")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/viewFFConsoExport");
      this.viewFFExportFCL();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      isLoading: "",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },

      FFExport: [],
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading
    CustomLoader,
  },

  computed: {},

  methods: {
    goToMain() {
      this.$sessionsStorage.set("editffFclConsoExportId", "");
      this.$router.push({
        path: "/ffExportCon/ffExportFclConsolidation",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#po").DataTable();
      });
    },

    viewExportFCLConPage(FCLCONID, status) {
      this.$sessionsStorage.set("editffFclConsoExportId", FCLCONID);
      let data = {
        jobType: "1",
        typeOf: "8",
        status: "",
        msgType: "1",
        allMessageId: FCLCONID,
        statusMain: status,
      };

      this.$sessionsStorage.set("MessageStatus", JSON.stringify(data));

      this.$router.push({
        path: "/UpdateStatus/clientChatScreen",
      });
    },
    viewFFExportFCL() {
      this.isLoading = true;
      let payload = {
        view: "view",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_ClientDashboard/ViewConsoExportListView.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            if (data.ffExportDetails.length > 0) {
              this.FFExport = data.ffExportDetails;
            } else {
              this.FFExport = [];
            }
            this.isLoading = false;
            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// clientSeaExpConso.vue?76b0a9f6